import { render, staticRenderFns } from "./ComoScanner.vue?vue&type=template&id=6c0e09a7&scoped=true&"
import script from "./ComoScanner.vue?vue&type=script&lang=js&"
export * from "./ComoScanner.vue?vue&type=script&lang=js&"
import style0 from "./ComoScanner.vue?vue&type=style&index=0&id=6c0e09a7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c0e09a7",
  null
  
)

export default component.exports